import { c as _c } from "react/compiler-runtime";
import { Select } from '@xefi/x-react/form';
import { t } from 'i18next';
import { useMemo } from 'react';
import type { QuestionChoice } from '@/models/question';
type SelectFieldProps = {
  choices: QuestionChoice[];
  value?: string;
  onChange: (value?: string) => void;
  canSelectNoOption: boolean;
  placeholder: string;
  disabled?: boolean;
  checkOverflow?: boolean;
};
export const SelectField = t0 => {
  const $ = _c(21);
  const {
    choices,
    value,
    onChange,
    placeholder,
    canSelectNoOption,
    disabled: t1,
    checkOverflow: t2
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const checkOverflow = t2 === undefined ? true : t2;
  let t3;
  let base;
  if ($[0] !== canSelectNoOption || $[1] !== checkOverflow || $[2] !== choices || $[3] !== placeholder) {
    let t4;
    if ($[5] !== checkOverflow) {
      t4 = choice_0 => {
        const isOverflowed = !!(choice_0.is_limit_overflowed && checkOverflow);
        const labelString = typeof choice_0.label === "string" ? choice_0.label : String(choice_0.label ?? "");
        return {
          key: choice_0.id,
          label: isOverflowed ? `${labelString} (${t("choice.unavailableShort").toLowerCase()})` : labelString,
          description: isOverflowed ? t("choice.unavailableShort") : undefined
        };
      };
      $[5] = checkOverflow;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    base = choices.filter(_temp).map(t4);
    if (canSelectNoOption) {
      base.unshift({
        key: "-1",
        label: `- ${placeholder ?? ""} -`,
        description: undefined
      });
    }
    $[0] = canSelectNoOption;
    $[1] = checkOverflow;
    $[2] = choices;
    $[3] = placeholder;
    $[4] = base;
  } else {
    base = $[4];
  }
  t3 = base;
  const options = t3;
  let t4;
  bb0: {
    if (!value) {
      t4 = undefined;
      break bb0;
    }
    let t5;
    if ($[7] !== value) {
      t5 = new Set([value]);
      $[7] = value;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t4 = t5;
  }
  const selectedKeys = t4;
  const isIterable = _temp2;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = selection => {
      if (!selection) {
        return;
      }
      if (typeof selection === "string") {
        return selection;
      }
      if (selection instanceof Set) {
        const arr = Array.from(selection as Set<string>);
        return arr[0];
      }
      if (Array.isArray(selection) || isIterable(selection) || selection && typeof (selection as {
        length: number;
      }).length === "number") {
        try {
          const maybeArr = Array.from(selection as ArrayLike<unknown> | Iterable<unknown>);
          return maybeArr[0] as string | undefined;
        } catch {
          return;
        }
      }
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const selectionToKey = t5;
  let t6;
  if ($[10] !== canSelectNoOption || $[11] !== checkOverflow || $[12] !== choices || $[13] !== onChange) {
    t6 = selection_0 => {
      const key = selectionToKey(selection_0);
      if (!key) {
        onChange(undefined);
        return;
      }
      const found = choices.find(choice_1 => choice_1.id === key);
      if (found?.is_limit_overflowed && checkOverflow) {
        return;
      }
      if (key === "-1" && canSelectNoOption) {
        onChange(undefined);
        return;
      }
      onChange(key);
    };
    $[10] = canSelectNoOption;
    $[11] = checkOverflow;
    $[12] = choices;
    $[13] = onChange;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const handleSelectionChange = t6;
  let t7;
  if ($[15] !== disabled || $[16] !== handleSelectionChange || $[17] !== options || $[18] !== placeholder || $[19] !== selectedKeys) {
    t7 = <div className="flex max-w-full flex-col gap-4"><Select options={options} value={selectedKeys} placeholder={placeholder} onSelectionChange={handleSelectionChange} isDisabled={disabled} radius="md" /></div>;
    $[15] = disabled;
    $[16] = handleSelectionChange;
    $[17] = options;
    $[18] = placeholder;
    $[19] = selectedKeys;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
function _temp(choice) {
  return choice.id !== undefined;
}
function _temp2(object) {
  return object != null && typeof object === "object" && Symbol.iterator in Object(object) && typeof (object as {
    [Symbol.iterator]: unknown;
  })[Symbol.iterator] === "function";
}